import Icon from '../components/Icon.vue'

Icon.register({
  'star-half-alt': {
    width: 536,
    height: 512,
    paths: [
      {
        d: 'M508.6 171.5c26.3 3.8 36.8 36.1 17.7 54.6l-105.9 103 25 145.5c3.6 20.8-13.1 37.4-31.7 37.4-4.9 0-10-1.2-14.8-3.7l-130.9-68.7-130.9 68.7c-4.9 2.6-9.9 3.8-14.9 3.8-18.6 0-35.2-16.7-31.6-37.5l25.1-145.5-105.9-103c-19-18.5-8.5-50.8 17.7-54.6l146.4-21.3 65.4-132.4c5.9-11.9 17.3-17.8 28.7-17.8 11.5 0 22.9 6 28.8 17.8l65.4 132.4zM386.8 294.7l82.7-80.4-114.2-16.6-25-3.6-11.2-22.6-51-103.3 0 317.2 22.4 11.7 102.1 53.6-19.5-113.5-4.3-24.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/star-half-alt.js
// module id = 1943
// module chunks = 0